require("./brokerCryptoTestSummary.scss");

// @vendors
import React from "react";
import PropTypes from "prop-types";
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
import { CryptoNavigationCard } from "../brokerCryptoNavigationCard/brokerCryptoNavigationCard";
import { CryptoModal } from "../components/brokerCryptoModal/brokerCryptoModal";
import { CryptoTooltip } from "../brokerCryptoTooltip/brokerCryptoTooltip";

// @helpers
import { taggingEventHandled } from 'utilities/taggingEventHandled';

// @constants
import { PROC_BROKER_CONVENIENCE_CRYPTO_TEST } from 'utilities/tagging';
import { APPROVED_TEST_RESULT, ANWSER_SELECTED_STATUS } from 'mifid/constants/constants'
export default function brokerCryptoTestSummary({
    previousAnseredQuestion,
    unansweredQuestions,
    goToEditQuestion,
    isModalOpen,
    handleModalClick,
    immBrokerConvenienceMiFIDTest,
}) {

    const handleEditQuestion = (questionId) => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'editMode', { element: questionId });
        goToEditQuestion(questionId);
    };

    const initializeModal = () => {
        taggingEventHandled(
            PROC_BROKER_CONVENIENCE_CRYPTO_TEST,
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'result']) === APPROVED_TEST_RESULT
                ? 'modalResultApprovedOpen' : 'modalResultDissaprovedOpen'
        );
    };

    const handleCloseModal = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST,
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'result']) === APPROVED_TEST_RESULT
                ? 'modalResultApprovedClose' : 'modalResultDissaprovedClose'
        );
        handleModalClick();
    }

    const handlePrimaryButtonClick = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST,
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'result']) === APPROVED_TEST_RESULT
                ? 'modalResultApprovedContinue' : 'modalResultDissaprovedContinue'
        );
        handleModalClick();
    };
    const result = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'result']);
    return (
        <div className="test-summary__container">
            {!unansweredQuestions.isEmpty() && (
                <>
                    <h2 className="test-summary__title">
                        {formatText("brokerCryptoTest-summaryTitle")}
                    </h2>
                    {unansweredQuestions.map((question) => {
                        const answers = question.get("answer");
                        const answerSelected = answers.filter(
                            (answer) => answer.get("selected") === ANWSER_SELECTED_STATUS
                        );
                        const description =
                            answerSelected.size > 0
                                ? answerSelected.get(0).get("description")
                                : "";
                        return (
                            <CryptoNavigationCard
                                type="answer"
                                title={description}
                                description={question.get("summaryLabel")}
                                onIconClick={() =>
                                    handleEditQuestion(question.get("id"))
                                }
                            />
                        );
                    })}
                    <CryptoModal
                        isOpen={isModalOpen}
                        onPrimaryButtonClick={() => handlePrimaryButtonClick()}
                        onOpen={()=>initializeModal()}
                        onClose={()=>handleCloseModal()}
                        title={formatText(`brokerCryptoTest-summary_resultModalContent_title_${result}`)}
                    >
                        <div className="test-summary__modal-content">
                            <FormattedText value={`brokerCryptoTest-summary_resultModalContent_description_${result}`}/>
                        </div>
                    </CryptoModal>
                </>
            )}
            {!previousAnseredQuestion.isEmpty() && (
                <>
                    <div className="test-summary__title-container">
                        <p className="test-summary__title">
                            {formatText("brokerCryptoTest-summaryPreviousAnsersTitle")}
                        </p>
                        <CryptoTooltip
                            content={
                                <div className="test-summary__tooltip-container">
                                    <FormattedText value="brokerCryptoTest-summary_tooltipContent"/>
                                </div>
                            }
                            title={formatText('brokerCryptoTest-summary_tooltipTitle')}
                        />
                    </div>
                    {previousAnseredQuestion.map((question) => {
                        const answers = question.get("answer");
                        const answerSelected = answers.filter(
                            (answer) => answer.get("selected") === ANWSER_SELECTED_STATUS
                        );
                        const description =
                            answerSelected.size > 0
                                ? answerSelected.get(0).get("description")
                                : "";
                        return (
                            <CryptoNavigationCard
                                type="answer"
                                title={description}
                                description={question.get("summaryLabel")}
                                onIconClick={() =>
                                    handleEditQuestion(question.get("id"))
                                }
                            />
                        );
                    })}
                </>
            )}
        </div>
    );
}

brokerCryptoTestSummary.propTypes = {
    previousAnseredQuestion: PropTypes.object.isRequired,
    unansweredQuestions: PropTypes.object.isRequired,
    goToEditQuestion: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    handleModalClick: PropTypes.func.isRequired,
};
